import { UserModel } from "../app/modules/auth/models/UserModel";

export function isAllowAddReimburse(
    remainingLimitYear: { idr: number | null; usd: number | null },
    remainingLimitMonth: { idr: number | null; usd: number | null }
): boolean {
    const isIdrInvalid = (remainingLimitYear.idr === null || remainingLimitYear.idr === 0) &&
        (remainingLimitMonth.idr === null || remainingLimitMonth.idr === 0);

    const isUsdInvalid = (remainingLimitYear.usd === null || remainingLimitYear.usd === 0) &&
        (remainingLimitMonth.usd === null || remainingLimitMonth.usd === 0);

    if ((remainingLimitYear.idr === null && remainingLimitMonth.idr === null) && (remainingLimitYear.usd === null && remainingLimitMonth.usd === null)) return false;
    if ((remainingLimitYear.idr === 0 || remainingLimitMonth.idr === 0) && (remainingLimitYear.usd === 0 || remainingLimitMonth.usd === 0)) return false;
    if (isIdrInvalid && isUsdInvalid) return false;

    return true
}

export function isAllowApproveReimburse(user: UserModel): boolean {
    if (user.data.is_superadmin) return true
    else if (user.data.canApproveReimbursement) return true
    else return false
}

export function isAllowUploadPaymentReimburse(user: UserModel): boolean {
    if (user.data.is_superadmin) return true
    else if (user.data.canUploadReimbursementProofOfPayment) return true
    else return false
}